import { makeStyles } from "@material-ui/core"

import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	portletContent: {
		padding: "40px"
	},
	disabledBox: {
		position: "relative",
		opacity: 0.5
	},
	expandAllButton: {
		border: "none",
		background: "none",
		padding: 0,
		fontSize: "11.5px",
		fontWeight: 500,
		color: themeColors.getPrimaryColor(),
		cursor: "pointer",
		"&:hover": {
			textDecoration: "underline"
		}
	}
}))

export default useStyles
